import { OIDC_CLIENT_ID, REALMS } from "@/constants/process";

export const EVBASIC_TOKEN_KEY = `oidc.user:${process.env.NEXT_PUBLIC_KEYCLOAK_URL}/realms/${REALMS.EVBASIC}:${OIDC_CLIENT_ID}`;
export const EVCORE_TOKEN_KEY = `oidc.user:${process.env.NEXT_PUBLIC_KEYCLOAK_URL}/realms/${REALMS.EVCORE}:${OIDC_CLIENT_ID}`;
